import { render } from "./frequency.vue?vue&type=template&id=27e1aece&scoped=true"
import script from "./frequency.vue?vue&type=script&lang=js"
export * from "./frequency.vue?vue&type=script&lang=js"

import "./frequency.vue?vue&type=style&index=0&id=27e1aece&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e1aece"]])

export default __exports__